import { Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'

import { CopyClipboardButton } from 'components/common/CopyClipboardButton'
import Icon, { IconName } from 'components/Icon'
import theme from 'theme'

export const DrawerUserDetail: React.FC<{
  clipboardOptions?: {
    content: string
    tooltipText: string
  }
  iconName: IconName
  text: string
}> = ({ clipboardOptions, iconName, text }) => (
  <>
    <Grid item css={{ textAlign: 'center' }} xs={2}>
      <Icon css={{ marginRight: theme.space[1] }} icon={iconName} />
    </Grid>

    <Grid item zeroMinWidth xs={8}>
      <Tooltip arrow title={text}>
        <Typography noWrap>{text}</Typography>
      </Tooltip>
    </Grid>

    <Grid item css={{ textAlign: 'center' }} xs={2}>
      {clipboardOptions?.content && (
        <CopyClipboardButton
          content={clipboardOptions.content}
          tooltipText={clipboardOptions.tooltipText}
        />
      )}
    </Grid>
  </>
)
